module.exports = __webpack_public_path__ + "img/1.f3a37456.webp";